<div class="filters">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchValue" (ngModelChange)="queueFilter($event)">
    <button *ngIf="searchValue" mat-icon-button matSuffix aria-label="Clear search" (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>

<div class="scroll-container" (scroll)="onScroll($event)">
  <table mat-table matSort [dataSource]="tableDataSource" class="table">
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
      <td mat-cell *matCellDef="let item">{{item.createdAt | date:'medium'}}</td>
    </ng-container>

    <ng-container matColumnDef="userName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>User Name</th>
      <td mat-cell *matCellDef="let item">{{item.userName}}</td>
    </ng-container>

    <ng-container matColumnDef="vendorName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
      <td mat-cell *matCellDef="let item">{{item.vendorName}}</td>
    </ng-container>

    <ng-container matColumnDef="vendorSession">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Session</th>
      <td mat-cell *matCellDef="let item">{{item.vendorSession}}</td>
    </ng-container>

    <ng-container matColumnDef="wallitSession">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Wallit Session</th>
      <td mat-cell *matCellDef="let item">{{item.wallitSession}}</td>
    </ng-container>

    <ng-container matColumnDef="phase">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Phase</th>
      <td mat-cell *matCellDef="let item">{{item.metadata?.phase}}</td>
    </ng-container>

    <ng-container matColumnDef="metadata">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Metadata</th>
      <td mat-cell *matCellDef="let item">{{getMetadata(item)}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let item">
        <button mat-icon-button [matMenuTriggerFor]="actionsMenu" [matMenuTriggerData]="{item: item}" (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
    <tr mat-row *matRowDef="let row; columns: columnNames"></tr>
  </table>

  <div class="loading" *ngIf="loading">Loading...</div>
  <div class="empty" *ngIf="!loading && items.length === 0">There are no user vendor products to show.</div>
</div>

<mat-menu #actionsMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <button mat-menu-item (click)="$event.stopPropagation(); editItem(item)">Edit</button>
    <ng-container *ngIf="hasVendorActions(item)">
      <mat-divider></mat-divider>
      <button mat-menu-item disabled>Vendor Actions (RxValet)</button>
      <button mat-menu-item (click)="$event.stopPropagation(); openRxValetSubscriptionUpdateDialog(item)">
        Update Subscription
      </button>
      <mat-divider></mat-divider>
    </ng-container>
    <button mat-menu-item *ngIf="sessionService.isSuperAdmin() && item.reinstatementSupported && item.metadata?.phase === 'terminated'"
      [disabled]="reinstating" (click)="$event.stopPropagation(); reinstate(item)">Re-Instate</button>
    <button mat-menu-item *ngIf="item.metadata?.phase === 'post'" (click)="$event.stopPropagation(); terminate(item)">Terminate</button>
    <button mat-menu-item *ngIf="item.metadata?.phase === 'error'" (click)="$event.stopPropagation(); forceTerminate(item)">
      Force Terminate
    </button>
    <button mat-menu-item (click)="$event.stopPropagation(); delete(item)">Delete</button>
  </ng-template>
</mat-menu>
